import { ref } from 'vue'

export function usePagination() {
  const currentPage = ref(1)
  const itemsPerPage = ref(20)

  function updatePage(page) {
    currentPage.value = page
  }

  function updateItemsPerPage(items) {
    itemsPerPage.value = items
    // Reset to the first page when items per page changes
    currentPage.value = 1
  }

  return {
    getCurrentPage: currentPage,
    getItemsPerPage: itemsPerPage,
    updatePage,
    updateItemsPerPage,
  }
}
